export default __webpack_public_path__ + "static/media/logo.704a7a4b.jpg";